<template>
  <div>
    <el-card>
      <el-row>
        <el-col>
          <el-date-picker
            v-model="starttime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-select
            style="margin-left: 10px"
            v-model="typeValue"
            placeholder="请选择食材类型"
            @visible-change="GetHe_FoodTypeList"
          >
            <el-option
              v-for="item in typeList"
              :key="item.Id"
              :label="item.value"
              :value="item.Id"
            >
            </el-option>
          </el-select>
          <el-button
            style="margin-left: 10px"
            type="goon"
            @click="GetHe_FoodMoonSummaryList"
            >查询</el-button
          >
          <el-button type="goon" @click="onClickOpen">导出</el-button>
          <el-button type="goon" @click="onEmpty">清空</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top: 20px">
      <div class="tui-box">
        <div
          class="tui-box-item"
          v-for="(item, index) in tabbar"
          :key="index"
          @click="onClickCurrent(index)"
          :class="currentIndex == index ? 'tui-box-active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="Name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="TypeName" label="种类" align="center">
        </el-table-column>
        <el-table-column prop="Count1" label="1" align="center">
        </el-table-column>
        <el-table-column prop="Count2" label="2" align="center">
        </el-table-column>
        <el-table-column prop="Count3" label="3" align="center">
        </el-table-column>
        <el-table-column prop="Count4" label="4" align="center">
        </el-table-column>
        <el-table-column prop="Count5" label="5" align="center">
        </el-table-column>
        <el-table-column prop="Count6" label="6" align="center">
        </el-table-column>
        <el-table-column prop="Count7" label="7" align="center">
        </el-table-column>
        <el-table-column prop="Count8" label="8" align="center">
        </el-table-column>
        <el-table-column prop="Count9" label="9" align="center">
        </el-table-column>
        <el-table-column prop="Count10" label="10" align="center">
        </el-table-column>
        <el-table-column prop="Count11" label="11" align="center">
        </el-table-column>
        <el-table-column prop="Count12" label="12" align="center">
        </el-table-column>
        <el-table-column prop="Count13" label="13" align="center">
        </el-table-column>
        <el-table-column prop="Count14" label="14" align="center">
        </el-table-column>
        <el-table-column prop="Count15" label="15" align="center">
        </el-table-column>
        <el-table-column prop="Count16" label="16" align="center">
        </el-table-column>
        <el-table-column prop="Count17" label="17" align="center">
        </el-table-column>
        <el-table-column prop="Count18" label="18" align="center">
        </el-table-column>
        <el-table-column prop="Count19" label="19" align="center">
        </el-table-column>
        <el-table-column prop="Count20" label="20" align="center">
        </el-table-column>
        <el-table-column prop="Count21" label="21" align="center">
        </el-table-column>
        <el-table-column prop="Count22" label="22" align="center">
        </el-table-column>
        <el-table-column prop="Count23" label="23" align="center">
        </el-table-column>
        <el-table-column prop="Count24" label="24" align="center">
        </el-table-column>
        <el-table-column prop="Count25" label="25" align="center">
        </el-table-column>
        <el-table-column prop="Count26" label="26" align="center">
        </el-table-column>
        <el-table-column prop="Count27" label="27" align="center">
        </el-table-column>
        <el-table-column prop="Count28" label="28" align="center">
        </el-table-column>
        <el-table-column prop="Count29" label="29" align="center">
        </el-table-column>
        <el-table-column prop="Count30" label="30" align="center">
        </el-table-column>
        <el-table-column prop="Count31" label="31" align="center">
        </el-table-column>
        <el-table-column prop="Count" label="合计" align="center">
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import {
  GetHe_FoodTypeList,
  GetHe_FoodMoonSummaryList,
} from "../../../api/api";
import {
  getMonthStartDate,
  getMonthEndDate,
} from "../../../../util/otherRenders";

export default {
  data() {
    return {
      options: [],
      value: "",
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      tabbar: [
        {
          name: "进货",
          Id: 1,
        },
        {
          name: "净重",
          Id: 2,
        },
      ],
      currentIndex: 0,
      starttime: [],
      pickerOptions: {
        // 点击时，选择的是开始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 解除限制
            this.selectData = "";
          }
        },
        disabledDate: (time) => {
          // 是否限制的判断条件
          if (!this.isNull(this.selectData)) {
            var date = new Date(this.selectData);
            // 这里就是限制的关键，大于或者小于本月的日期被禁用
            return (
              date.getMonth() > new Date(time).getMonth() ||
              date.getMonth() < new Date(time).getMonth()
            );
          } else {
            return false;
          }
        },
      },
      selectData: "",
      typeList: [],
      typeValue: null,
      userInfo: {},
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    await this.getNowTime();
    await this.GetHe_FoodMoonSummaryList();
  },
  methods: {
    // 导出
    async onClickOpen() {
      window.open(
        `http://apiv3.mushroomisland.cn/api/mgd/He_FoodReportTableControlle/Export_GetHe_FoodMoonSummaryList?SchoolId=${this.userInfo.SchoolId}&StartDate=${this.starttime[0]}&EndDate=${this.starttime[1]}`,
        "_brank"
      );
    },
    // 清空
    onEmpty() {
      this.typeValue = null;
      this.GetHe_FoodMoonSummaryList();
    },
    async GetHe_FoodMoonSummaryList() {
      const params = {
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
        FoodTypeId: this.typeValue,
        Type: this.tabbar[this.currentIndex].Id,
      };
      let res = await GetHe_FoodMoonSummaryList(params);
      if (res.data.success) {
        this.tableData = res.data.response;
      } else {
        this.tableData = [];
      }
    },

    async GetHe_FoodTypeList() {
      let res = await GetHe_FoodTypeList();
      if (res.data.success) {
        this.typeList = res.data.response;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async getNowTime() {
      this.starttime.push(getMonthStartDate());
      this.starttime.push(getMonthEndDate());
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    onClickCurrent(index) {
      this.currentIndex = index;
      this.GetHe_FoodMoonSummaryList();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.tui-box {
  width: 130px;
  height: 30px;
  background: #e5ebff;
  border-radius: 15px;
  border: 1px solid #cdcdcd;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  .tui-box-item {
    width: 65px;
    height: 100%;
    cursor: pointer;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }
  .tui-box-active {
    background: #5474e6 !important;
    color: #fff !important;
  }
}
</style>